import { render, staticRenderFns } from "./CreateLotInstrument.vue?vue&type=template&id=0fda8472"
import script from "./CreateLotInstrument.vue?vue&type=script&lang=js"
export * from "./CreateLotInstrument.vue?vue&type=script&lang=js"
import style0 from "./CreateLotInstrument.vue?vue&type=style&index=0&id=0fda8472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports